var _style, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-280 364.6 50.6 64.4",
    style: {
      enableBackground: "new -280 364.6 50.6 64.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#298BC1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-238.1,401.3c0,4.4-4.1,8.8-6.5,10.6c-3.9,3.4-7.7,5.3-8.9,5.5c-1.2-0.3-5.1-2.1-8.9-5.5 c-2.4-2.2-6.5-6.3-6.5-10.6v-19.7c5.5-0.6,10.8-2.2,15.4-5c4.9,2.8,10,4.5,15.5,5.1L-238.1,401.3L-238.1,401.3z M-234.4,378 c-6.7,0-13.3-2-19.1-5.9c-5.7,3.9-12.7,5.8-19.4,5.9l0,0v23.2c0,10.6,15.7,20.2,19.4,20.2s19.4-9.4,19.4-20.2V378l0,0 C-234.3,378-234.3,378-234.4,378z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-240.2,384c-4.7-0.1-9.3-1.5-13.3-4.2c-3.8,2.5-8.5,3.9-13.3,4.2v16.1c0,7.3,10.8,13.8,13.3,13.8 s13.3-6.5,13.3-13.8L-240.2,384L-240.2,384z M-241.7,400c0,3.5-3.1,6.7-5,8.2c-3,2.6-5.8,3.9-6.7,4.1h-0.2h-0.2 c-0.8-0.3-3.7-1.5-6.7-4.1c-1.8-1.6-5-4.9-5-8.2v-14.7l0.6-0.1c3.8-0.3,7.6-1.6,10.9-3.6l0.3-0.3l0.3,0.3c3.4,2,7.1,3.2,10.9,3.6 l0.6,0.1V400H-241.7z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-244.1,387.6c-2,2.2-3.8,4.4-5.6,6.7c-1.7,2.3-3.3,4.7-4.7,7.3c-0.1,0.2-0.3,0.4-0.3,0.7 c-0.4,0.9-1.3,1.5-2.2,1.5c-0.3,0-0.7-0.1-0.9-0.2c-0.3-0.1-0.4-0.3-0.7-0.6c-0.2-0.3-0.3-0.5-0.4-0.9c-0.2-0.3-0.3-0.9-0.5-1.7 c0-0.1,0-0.1-0.1-0.2c-0.3-0.8-0.3-1.4-0.3-1.6c0-0.4,0.3-0.8,0.7-1.3c0.5-0.3,0.9-0.5,1.6-0.5c0.2,0,0.3,0.1,0.3,0.2 c0.1,0.1,0.3,0.3,0.3,0.6c0.1,0.2,0.2,0.4,0.3,0.7c0.3,0.7,0.4,1.1,0.7,1.1c0.2,0,0.7-0.8,1.8-2.5c0.9-1.6,1.8-3,2.6-4 c0.9-1.6,1.7-2.6,2.2-3.3s0.9-1.3,1.5-1.6c0.3-0.3,0.8-0.5,1.5-0.7c0.6-0.2,1.3-0.3,2.2-0.3L-244.1,387.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.ce158e1db45a86af80842eaa2680efcb.svg";
export { ForwardRef as ReactComponent };